define("shared/components/shared/post/secondary/hashtag-suggestions/free-upgrade-modal", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _component2, _object, _service, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="o--modalBody--secondary u--p__0 has--footer">
    <div class="cMH--blank">
      <Shared::Post::Secondary::HashtagSuggestions::UpgradeModalBackground/>
  
      <div class="cMH--blank__overlay">
        {{!-- Header --}}
        <p class="u--p__lr__lg u--m__b__md ">{{t "hashtag_suggestions.limited.upgrade_modal_free.title"}}</p>
  
        {{!-- Auto Hashtags --}}
        <label class={{concat-classes "cMH--upgradeCard " (if this.isAutoSelected "is--active")}} onClick={{fn this.toggleButtonTab "auto"}}>
          <div class="cMH--upgradeCard__input">
            <div class="u--p__r__xs">
              <Input
                class="u--cursor qa--autoHashtag_radioBtn"
                id="RadioButtonID"
                name="RadioButtonName"
                @type="radio"
              />
            </div>
            <div class="u--block">
              <p class="u--text--bold u--m__b__0 qa--autoHashtagOption">{{t "hashtag_suggestions.limited.upgrade_modal_free.auto_button.header"}}</p>
              <p class="u--m__b__0">{{t "hashtag_suggestions.limited.upgrade_modal_free.auto_button.detail"}}</p>
            </div>
          </div>
          {{!-- Auto Hashtags Details --}}
          {{#if this.isAutoSelected}}
            <Shared::Post::Secondary::HashtagSuggestions::FreeUpgradeModalDetails @planName={{this.planName}} @isAutoSelected={{this.isAutoSelected}}/>
          {{/if}}
        </label>
  
        {{!-- Search Hashtags --}}
        <label class={{concat-classes "cMH--upgradeCard " (if this.isSearchSelected "is--active")}} onClick={{fn this.toggleButtonTab "search"}}>
          <div class="cMH--upgradeCard__input">
            <div class="u--p__r__xs">
              <Input
                class="u--cursor qa--searchHashtag_radioBtn"
                id="RadioButtonID"
                name="RadioButtonName"
                @type="radio"
              />
            </div>
            <div class="u--block">
              <p class="u--text--bold u--m__b__0 qa--searchHashtagOption">{{t "hashtag_suggestions.limited.upgrade_modal_free.search_button.header"}}</p>
              <p class="u--m__b__0">{{t "hashtag_suggestions.limited.upgrade_modal_free.search_button.detail"}}</p>
            </div>
          </div>
          {{!-- Search Hashtags Details Modal --}}
          {{#if this.isSearchSelected}}
            <Shared::Post::Secondary::HashtagSuggestions::FreeUpgradeModalDetails @planName={{this.planName}} @isAutoSelected={{this.isAutoSelected}}/>
          {{/if}}
        </label>
  
      </div>
    </div>
  </section>
  
  */
  {
    "id": "4h+SkNxR",
    "block": "[[[10,\"section\"],[14,0,\"o--modalBody--secondary u--p__0 has--footer\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cMH--blank\"],[12],[1,\"\\n    \"],[8,[39,0],null,null,null],[1,\"\\n\\n    \"],[10,0],[14,0,\"cMH--blank__overlay\"],[12],[1,\"\\n\"],[1,\"      \"],[10,2],[14,0,\"u--p__lr__lg u--m__b__md \"],[12],[1,[28,[35,1],[\"hashtag_suggestions.limited.upgrade_modal_free.title\"],null]],[13],[1,\"\\n\\n\"],[1,\"      \"],[10,\"label\"],[15,0,[28,[37,2],[\"cMH--upgradeCard \",[52,[30,0,[\"isAutoSelected\"]],\"is--active\"]],null]],[15,\"onClick\",[28,[37,4],[[30,0,[\"toggleButtonTab\"]],\"auto\"],null]],[12],[1,\"\\n        \"],[10,0],[14,0,\"cMH--upgradeCard__input\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--p__r__xs\"],[12],[1,\"\\n            \"],[8,[39,5],[[24,0,\"u--cursor qa--autoHashtag_radioBtn\"],[24,1,\"RadioButtonID\"],[24,3,\"RadioButtonName\"]],[[\"@type\"],[\"radio\"]],null],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"u--block\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold u--m__b__0 qa--autoHashtagOption\"],[12],[1,[28,[35,1],[\"hashtag_suggestions.limited.upgrade_modal_free.auto_button.header\"],null]],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,1],[\"hashtag_suggestions.limited.upgrade_modal_free.auto_button.detail\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"isAutoSelected\"]],[[[1,\"          \"],[8,[39,6],null,[[\"@planName\",\"@isAutoSelected\"],[[30,0,[\"planName\"]],[30,0,[\"isAutoSelected\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\\n\"],[1,\"      \"],[10,\"label\"],[15,0,[28,[37,2],[\"cMH--upgradeCard \",[52,[30,0,[\"isSearchSelected\"]],\"is--active\"]],null]],[15,\"onClick\",[28,[37,4],[[30,0,[\"toggleButtonTab\"]],\"search\"],null]],[12],[1,\"\\n        \"],[10,0],[14,0,\"cMH--upgradeCard__input\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--p__r__xs\"],[12],[1,\"\\n            \"],[8,[39,5],[[24,0,\"u--cursor qa--searchHashtag_radioBtn\"],[24,1,\"RadioButtonID\"],[24,3,\"RadioButtonName\"]],[[\"@type\"],[\"radio\"]],null],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"u--block\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold u--m__b__0 qa--searchHashtagOption\"],[12],[1,[28,[35,1],[\"hashtag_suggestions.limited.upgrade_modal_free.search_button.header\"],null]],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,1],[\"hashtag_suggestions.limited.upgrade_modal_free.search_button.detail\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"isSearchSelected\"]],[[[1,\"          \"],[8,[39,6],null,[[\"@planName\",\"@isAutoSelected\"],[[30,0,[\"planName\"]],[30,0,[\"isAutoSelected\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[],false,[\"shared/post/secondary/hashtag-suggestions/upgrade-modal-background\",\"t\",\"concat-classes\",\"if\",\"fn\",\"input\",\"shared/post/secondary/hashtag-suggestions/free-upgrade-modal-details\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/free-upgrade-modal.hbs",
    "isStrictMode": false
  });

  var Tabs;

  (function (Tabs) {
    Tabs["Auto"] = "auto";
    Tabs["Search"] = "search";
    Tabs["None"] = "none";
  })(Tabs || (Tabs = {}));

  let FreeUpgradeModal = (_class = class FreeUpgradeModal extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "intl", _descriptor, this);

      _initializerDefineProperty(this, "segment", _descriptor2, this);

      _defineProperty(this, "Tabs", Tabs);

      _initializerDefineProperty(this, "currentTab", _descriptor3, this);
    }

    get isAutoSelected() {
      return this.currentTab == this.Tabs.Auto;
    }

    get isSearchSelected() {
      return this.currentTab == this.Tabs.Search;
    }

    get planName() {
      // Note: returns the name of the plan the current tab upgrades to
      return this.isAutoSelected ? this.intl.t('plans.plan_names.growth') : this.intl.t('plans.plan_names.starter');
    }

    toggleButtonTab(tab) {
      this.currentTab = tab;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "currentTab", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return this.Tabs.None;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleButtonTab", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleButtonTab"), _class.prototype)), _class);
  _exports.default = FreeUpgradeModal;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FreeUpgradeModal);
});